import { ANDROID_WRAPPER_EVENTS } from '@/event-manager/types';
import { PLATFORMS } from '@/utilities/constants/game';
import { getPlatform } from '@/utilities/getters/gameContextGetters';
import { sendAndroidWrapperEvent } from '@/utilities/helpers/wrapperHelpers';

export const openExternalBrowser = (url) => {
  window?.Android?.redirectToBrowser?.(url);
  window?.AndroidSportsbook?.openExternalWebView?.(url);
};

export const openInWebView = (url) =>
  getPlatform() === PLATFORMS.XSELL
    ? sendAndroidWrapperEvent(ANDROID_WRAPPER_EVENTS.OPEN_EXTERNAL_WEBVIEW, url)
    : window.open(url, '_blank');

export const openURLMobile = (url, openExternal: boolean) =>
  openExternal ? openExternalBrowser(url) : openInWebView(url);
